<script>
    import { onMount } from "svelte";
    import Typeahead from "../_components/Typeahead.svelte";
    import guff from "dataset:../_data/guff.aml";

    /** @type {String} [placeholder_mobile_override="Search by insitution or state"] - By default, the map has a placeholder. On mobile in CMS, a shorter placeholder value is needed. {% svelteSsr  'SearchBox', {placeholder_mobile_override: "Search for an institution or tribe"} %} */
    export let placeholder_mobile_override;
    
    const PATH_PREFIX =
        process.env.BAKER_FOR_CMS === "1"
            ? // When building component for CMS usage, use a full URL like
              // `https://projects.propublica.org/repatriation/...`
              `${process.env.DOMAIN}${process.env.PATH_PREFIX}`
            : // When building for app itself, root-relative URL is fine (and probably
              // less prone to bugs): `/repatriation/...`
              process.env.PATH_PREFIX;

    let data = [];

    let innerWidth = 0;
    let isMobile = false;

    const extract = (item) => {
        if ("subunits" in item && item.subunits.length > 0) {
            let searchList = [item.name];
            item.subunits.forEach((i) => {
                searchList.push(item.name + " | " + i);
            });
            return searchList;
        } else {
            return [item.name];
        }
    };
    /** @type {any[]} */
    const equivalencies = [["dept", "department"]];

    onMount(async () => {
        ({ default: data } = await import(
            // @ts-expect-error
            "dataset:../_data/search/searchData.js"
        ));

        isMobile = innerWidth < 501;
    });
</script>

<svelte:window bind:innerWidth />
<Typeahead
    label=""
    placeholder={placeholder_mobile_override && (!innerWidth || innerWidth < 500) ? placeholder_mobile_override : guff.search_placeholder}
    limit={isMobile ? 3 : 4}
    id="search-input"
    type="search"
    inputAfterSelect="clear"
    {data}
    autoselect={false}
    {extract}
    {equivalencies}
    on:select={(d) => {
        let data = d.detail.original;
        let url = `${PATH_PREFIX}${data.type}/${data.slug}/`;
        window.location.href = url;
    }}
    let:result
    let:index
    let:value
>
    <div>
        <span class="search-result">{result.original.name}</span><span
            class="search-preview">{result.preview}</span
        >
    </div>
    <div class="search-context-type">
        <small
            >{result.original.type == "tribe"
                ? result.original.subtype
                : result.original.type}</small
        >
    </div>

    <svelte:fragment slot="no-results">
        No results found for "{value}"
    </svelte:fragment>
</Typeahead>

<style>
    :global([role="listbox"]) {
        margin: 0;
    }

    .search-result {
        line-height: var(--line-height-2);
        padding: var(--spacing-2) 0;
    }

    div.search-context-type {
        font-size: var(--scale-2);
        text-transform: capitalize;
        margin-top: 0;
        line-height: 1em;
        position: relative;
        top: -3px;
        color: var(--font-gray, --gray-50);
    }
</style>
